export const docList = [
  {
    docName: "HR Portal - Quick Access",
    fileName: "HR Portals.pdf",
    author: "Ashok Kumar",
    date: "31 Feb. 2024",
  },
  {
    docName: "Alumni Registration - HR Berry Portal",
    fileName: "Alumni Registration.pdf",
    author: "",
    docAuthor: "System Generated",
    date: "31 Feb. 2024",
  },
  {
    docName: "Separation Guidebook",
    fileName: "Exit Process Employee Guidebook.pdf",
    author: "Ashok Kumar",
    date: "31 Feb. 2024",
  },
  {
    docName: "Holiday List",
    fileName: "Holiday List 2024 - HO & Circle Offices.pdf",
    author: "",
    docAuthor: "System Generated",
    date: "31 Feb. 2024",
  },
  {
    docName: "HR Portal - Quick Access",
    fileName: "Happay Portal User Manual.pdf",
    author: "Ashok Kumar",
    date: "31 Feb. 2024",
  },
  {
    docName: "Miscellaneous",
    fileName: "POSH Policy.pdf",
    author: "Ashok Kumar",
    date: "31 Feb. 2024",
  },
  {
    docName: "Miscellaneous",
    fileName: "Holiday List 2023 - HO & Circle Offices.pdf",
    author: "Ashok Kumar",
    date: "31 Feb. 2024,",
  },
  {
    docName: "Miscellaneous",
    fileName: "Rehire Policy-MRPL-1st June 2024.pdf",
    author: "Ashok Kumar",
    date: "31 Feb. 2024",
  },
];
export const uploadList = [
  {
    docName: "Personal Documents",
    fileName: "Confirmation Letter.pdf",
    docAuthor: "System Generated",
    date: "31 Feb, 2024",
  },
  {
    docName: "Miscellaneous",
    fileName: "Graduation Degree & Marksheet.pdf",
    author: "Ashok Kumar",
    date: "31 Feb, 2024",
  },
  {
    docName: "Personal Documents",
    fileName: "Pan Card.jpeg",
    author: "Ashok Kumar",
    date: "31 Feb, 2024",
  },
  {
    docName: "Personal Documents",
    fileName: "Cancelled Cheque.jpeg",
    author: "Ashok Kumar",
    date: "31 Feb, 2024",
  },
  {
    docName: "Miscellaneous",
    fileName: "BE - Appointment Letter - JB 9 & Below.pdf",
    docAuthor: "System Generated",
    date: "31 Feb, 2024",
  },
  {
    docName: "Personal Documents",
    fileName: "Aadhar Card Front.jpg",
    author: "Ashok Kumar",
    date: "31 Feb, 2024",
  },
  {
    docName: "Personal Documents",
    fileName: "Aadhar Card Back.jpg",
    author: "Ashok Kumar",
    date: "31 Feb, 2024",
  },
];
